/**
 * Werkruimtes (MA-72): twee projecten in één app, elk met zijn eigen data.
 *
 * *Huizen* is de huizenzoektocht, alles van vóór MA-72. *SportCity* zoekt
 * locaties voor nieuwe clubs. Per account staat vast in welke werkruimtes het
 * mag kijken; de API weigert een endpoint van een werkruimte waar het account
 * niet in zit. Wie er meer dan één heeft, wisselt bovenin de rail.
 */
import { z } from 'zod';

export const WERKRUIMTES = ['huizen', 'sportcity'] as const;

export const werkruimteSchema = z.enum(WERKRUIMTES);
export type Werkruimte = z.infer<typeof werkruimteSchema>;

export const WERKRUIMTE_LABELS: Record<Werkruimte, string> = {
  huizen: 'Huizen',
  sportcity: 'SportCity',
};

/**
 * Waar een endpoint zonder eigen markering bij hoort, en wat een nieuw account
 * krijgt als `seed-users.json` er niets over zegt: alles van vóór MA-72 is Huizen.
 */
export const WERKRUIMTE_STANDAARD: Werkruimte = 'huizen';

/** Zet een lijst in de vaste volgorde, zonder dubbele; onbekende namen vallen weg. */
export function ordenWerkruimtes(lijst: readonly string[]): Werkruimte[] {
  return WERKRUIMTES.filter((werkruimte) => lijst.includes(werkruimte));
}
